import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=a97774fc&scoped=true&"
import script from "./ColumnHeader.vue?vue&type=script&lang=js&"
export * from "./ColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&id=a97774fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97774fc",
  null
  
)

export default component.exports